import styled from 'styled-components/macro';
import { colorCoreWhite1000, colorCoreBlack1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
export const WrapperStyled = styled.div `
  padding: 48px 24px 24px 24px;
  background: ${colorCoreWhite1000};
  overflow-y: hidden;

  ${ADAPTIVE.minWidth.desktop} {
    padding: 22px 8px 6px 8px;
    box-shadow: ${elevationBottomLvl2};
    border-radius: ${CORNER_RADIUS.m};
  }
`;
export const SeparatorStyled = styled.div `
  width: 14px;
  height: 1.5px;
  background-color: ${colorCoreBlack1000};
  border-radius: ${CORNER_RADIUS.xxs};
  margin: 0 10px;
`;
